import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const url = '/api/v4/parent/user/marketing-preferences';

export default {
    state: {
        marketingPreferencesStatus: false
    },

    getters: {
        marketingPreferencesStatus(state) {
            return state.marketingPreferencesStatus;
        }
    },

    actions: {
        async GET_PREFERENCES(context, payload) {
            try {

                const request = new Request(url, {
                    method: 'GET',
                    credentials: 'same-origin'
                });

                const response = await fetch(request);
                const json = await response.json();

                context.commit('SET_PREFERENCES', json);
            } catch (error) {
                console.error(error);
            }
        },

        async SET_PREFERENCES(context, payload) {
            try {

                const request = new Request(url, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        optIn: payload.status
                    })
                });

                const response = await fetch(request);
                const json = await response.json();

                context.commit('SET_PREFERENCES', payload);
            } catch (error) {
                console.error(error);
            }
        }
    },

    mutations: {
        SET_PREFERENCES(state, payload) {
            state.marketingPreferencesStatus = payload.status;
        }
    }
};
